import { render, staticRenderFns } from "./elementPreview.vue?vue&type=template&id=f56d0832"
import script from "./elementPreview.vue?vue&type=script&lang=js"
export * from "./elementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports